import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import {lang} from "../../shared/lang/lang.nl";
import {AccessControlService} from "../../core/access-control/access-control.service";
import {ApiService} from "../../core/api/api.service";
import {LoginRequestModel, LoginResponseModel} from "../../shared/models/login/login.model";
import {environment} from "../../../environments/environment";
import {MeModel} from "../../shared/models/login/me.model";

@Component({
    selector: 'bergh-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {
  lang = lang;
  loginForm: UntypedFormGroup;
  loading: boolean = false;

  constructor( private _router: Router,
               private _formBuilder: UntypedFormBuilder,
               private _accessControl: AccessControlService,
               private _api: ApiService ) { }

  ngOnInit(): void {
    this.loginForm = this._formBuilder.group({
      'email':['', [Validators.required,Validators.email]],
      'password':['', [Validators.required]]
    })
  }

  //##################################
  //        G E T T E R S
  //##################################

  /**
   * gets the email value
   *
   * @returns string
   */
  public get emailGet(): string {
    return this.loginForm.controls['email'].value;
  }

  /**
   * gets the password value
   *
   * @returns string
   */
  public get passwordGet(): string {
    return this.loginForm.controls['password'].value;
  }

  /**
   * @description This methord handles the login functionality.
   * @returns void
   */
  public login(): void {
    if (this.loginForm.valid) {
      this.loginForm.controls['email'].setValue((this.emailGet).trim());
      this.loading = true;

      //Setting the login request payload
      let loginRequestPayload: LoginRequestModel = {
        grant_type: environment.GRANT_TYPE,
        client_id: environment.CLIENT_ID,
        username: this.emailGet,
        password: this.passwordGet
      }

      //######################################//
      //  R E Q U E S T   F O R   L O G I N   //
      //######################################//
      this._api.request('oauth',loginRequestPayload).subscribe((result: LoginResponseModel) => {
        if (this._accessControl.setToken(result.access_token,result.refresh_token)) {
          this.me();
        }
      },(error: any) => {
        console.error(error)
        return this.loading = false;
      });
    }
  }

  /**
   * @description ME endpoint is called here and on success the user is redirected to thr root of the system.
   * @returns void
   */
  public me(): void {
    this._api.request('me').subscribe((result: MeModel) => {
      if (this._accessControl.setMe(result)) {
        this.loading = false;
        this._router.navigate(['']);
      }
    },(error: any) => {
      console.error(error)
      this.loading = false;
    });
  }
}
